import script from "./CompanyBillingAddressTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyBillingAddressTab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__